document.addEventListener('DOMContentLoaded', function () {
    // Configuración
    const MAPPING = {
        'Desktop': 'OTF',
        'Webfont': 'WOFF2',
        'App': 'OTF',
        'E-pub': 'OTF',
        'Digital Ads': 'WOFF2'
    };

    const VARIANT_PICKER_SELECTOR = 'variant-selects';

    function init() {
        // Observar cambios en el DOM para detectar cuando carga Expo
        const observer = new MutationObserver((mutations) => {
            // Intentar encontrar los inputs de opciones de Expo
            // Buscamos inputs de tipo radio o checkbox, o botones que parezcan opciones
            // Ampliamos selectores para cubrir más casos de Expo
            const expoInputs = document.querySelectorAll('input[name*="option"], .expo-option, [class*="expo"] input[type="radio"], [class*="expo"] input[type="checkbox"]');

            if (expoInputs.length > 0) {
                attachListeners(expoInputs);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function attachListeners(inputs) {
        inputs.forEach(input => {
            // Evitar doble binding
            if (input.dataset.linked) return;
            input.dataset.linked = 'true';

            input.addEventListener('change', (e) => {
                handleLicenseChange(e.target);
            });

            // También escuchar clicks si son divs/botones
            input.addEventListener('click', (e) => {
                // Si es un input, el evento change ya lo maneja
                if (e.target.tagName === 'INPUT') return;
                handleLicenseChange(e.target);
            });
        });
    }

    function handleLicenseChange(target) {
        // Obtener el texto de la etiqueta asociada o del propio elemento
        let labelText = '';

        // Caso 1: Input con label asociado
        if (target.id && document.querySelector(`label[for="${target.id}"]`)) {
            labelText = document.querySelector(`label[for="${target.id}"]`).innerText;
        }
        // Caso 2: El input está dentro del label
        else if (target.closest('label')) {
            labelText = target.closest('label').innerText;
        }
        // Caso 3: Es un elemento con texto directo (div, span, button)
        else if (target.innerText) {
            labelText = target.innerText;
        }
        // Caso 4: Valor del input
        else {
            labelText = target.value;
        }

        // Buscar coincidencia en el mapa
        let formatToSelect = null;
        for (const [license, format] of Object.entries(MAPPING)) {
            if (labelText && labelText.toLowerCase().includes(license.toLowerCase())) {
                formatToSelect = format;
                break;
            }
        }

        if (formatToSelect) {
            updateShopifyVariant(formatToSelect);
        }
    }

    function updateShopifyVariant(formatValue) {
        const variantSelects = document.querySelector(VARIANT_PICKER_SELECTOR);
        if (!variantSelects) return;

        // Buscar el input/select que controla el "Format"

        // 1. Intentar encontrar inputs radio ocultos (Pill/Swatch)
        // Buscamos inputs cuyo valor sea OTF o WOFF2 (case insensitive)
        const radioInputs = Array.from(variantSelects.querySelectorAll('input[type="radio"]'));
        const targetRadio = radioInputs.find(input => {
            // Verificamos si el valor del input coincide con el formato deseado
            return input.value.trim().toLowerCase() === formatValue.toLowerCase();
        });

        if (targetRadio) {
            if (!targetRadio.checked) {
                targetRadio.checked = true;
                targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
                targetRadio.click(); // A veces necesario para disparar listeners de Shopify

                // Disparar evento personalizado para notificar a otros componentes
                document.dispatchEvent(new CustomEvent('license:format:changed', {
                    detail: { format: formatValue }
                }));
            }
            return;
        }

        // 2. Intentar encontrar select dropdown
        const selects = variantSelects.querySelectorAll('select');
        selects.forEach(select => {
            // Verificamos si alguna opción del select coincide
            const optionToSelect = Array.from(select.options).find(opt => opt.value.trim().toLowerCase() === formatValue.toLowerCase());

            if (optionToSelect) {
                if (select.value !== optionToSelect.value) {
                    select.value = optionToSelect.value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));

                    // Disparar evento personalizado para notificar a otros componentes
                    document.dispatchEvent(new CustomEvent('license:format:changed', {
                        detail: { format: formatValue }
                    }));
                }
            }
        });
    }

    init();
});
